import styled from "@emotion/styled";

export const ViewUsersTableContainer = styled.div`
    width: 100%;
    max-height: 72vh;
    font-family: "Helvetica", Arial, sans-serif;
    padding: 0px 1rem;
    overflow-y: auto;

    th,
    td {
        text-align: center;
    }
`;

export const ActionsCard = styled.div`
    display: flex;
    flex-direction: row;
    gap: 10px;
    width: 100%;
    align-items: center;
    justify-content: start;
`;

export const ActionButtons = styled.button<{
    backgroundColorHex?: string;
}>`
    width: 100%;
    text-transform: capitalize;
    padding: 0.55rem 1.125rem;
    border-radius: 0.375rem;
    font-size: 0.9em;
    font-weight: 600;
    color: rgb(255, 255, 255);
    background-color: ${(props) => props.backgroundColorHex ?? "rgb(22 59 93)"};
    text-decoration: none;
    font-family: Helvetica, Arial, sans-serif;
    border: navajowhite;
    cursor: pointer;
`;

export const ActionButtonsWrapper = styled.div`
    min-width: 165px;
`;

export const SearchBar = styled.div`
    display: flex;
    justify-content: flex-end;
    padding: 0 0 0.75rem 0;
`;

export const SearchInput = styled.input`
    width: 100%;
    max-width: 340px;
    padding: 0.55rem 0.75rem;
    border-radius: 0.375rem;
    border: 1px solid rgb(226, 232, 240);
    font-size: 0.9rem;
    font-family: Helvetica, Arial, sans-serif;

    &:focus {
        outline: none;
        border-color: rgb(22 59 93);
    }
`;
